export interface Post {
  id: string;
  userId: string;
  content: string;
  imageUrl?: string;
  tournamentId?: string;
  createdAt: Date;
  updatedAt: Date;
}

export interface PostWithDetails extends Post {
  userName?: string;
  userEmail?: string;
  userAvatarUrl?: string;
  tournamentName?: string;
  tournamentIsPublic?: boolean;
  likeCount: number;
  isLikedByUser: boolean;
}

export interface PublicPost extends Post {
  userName?: string;
  userAvatarUrl?: string;
  tournamentName?: string;
  tournamentIsPublic: boolean;
  likeCount: number;
}
